__turbopack_context__.v({
  "articles": "GDnwYa_articles",
  "container": "GDnwYa_container",
  "content": "GDnwYa_content",
  "info": "GDnwYa_info",
  "label": "GDnwYa_label",
  "layout--centered": "GDnwYa_layout--centered",
  "layout--default": "GDnwYa_layout--default",
  "layout--fullWidth": "GDnwYa_layout--fullWidth",
  "subtitle": "GDnwYa_subtitle",
  "title": "GDnwYa_title",
});
